/*
  Product Nav
 */

var ProductNav = (function ($) {
  var m = (function () {
    var name = 'Product Nav';
    var version = '0.0.1';

    /*
      Local variable declarations
    */

    /*
      Handlers
    */
    var handlers = {
      addItemActiveClass: function ($item) {
        $item.addClass('is-active');
      },
      removeItemActiveClass: function ($item) {
        $item.removeClass('is-active');
      },
    };

    /*
      List handlers that should be
      accessible in the global namespace
    */
    var publicHandlers = [
    ];

    /*
      Events
    */
    var events = {
      onItemBlur: function () {
        $('.js-product-nav__item').each(function () {
          var $this = $(this);

          $this.on('focusout mouseleave', function () {
            handlers.removeItemActiveClass($this);
          });
        });
      },
      onItemFocus: function () {
        $('.js-product-nav__item').each(function () {
          var $this = $(this);

          $this.on('focusin mouseenter', function () {
            handlers.addItemActiveClass($this);
          });
        });
      },
      pageLoad: function () {
      },
    };

    /*
      List events in the order they
      should be bound. Any unlisted
      events will be registered last.
    */
    var eventOrder = [
      'pageLoad',
    ];

    /************************************************************************************
      DON'T EDIT BELOW THIS LINE
    ************************************************************************************/

    var bindEvents = function () {
      var eventNames = Object.keys(events);
      for (var i = 0; i < eventNames.length; i++) {
        var eventName = eventNames[i];
        if (eventOrder.indexOf(eventName) < 0) {
          eventOrder.push(eventName);
        }
      }

      for (var i = 0; i < eventOrder.length; i++) {
        var eventName = eventOrder[i];
        var event = events[eventName];

        if (event !== undefined) {
          if (typeof (event) === 'function') {
            try {
              event();
            }
            catch (e) {
              console.error('Event binding failed: ' + eventName);
              console.error(e);
            }
          }
          else {
            console.error('Event is not a function: ' + eventName);
          }
        }
        else {
          console.error('Event is undefined: ' + eventName);
        }
      }
    };

    var registerPublicHandlers = function () {
      for (var i = 0; i < publicHandlers.length; i++) {
        var handlerName = publicHandlers[i];
        var handler = handlers[handlerName];
        if (handler !== undefined) {
          if (typeof (handler) === 'function') {
            interface[handlerName] = handler;
          }
          else {
            console.error('Handler is not a function: ' + handlerName);
          }
        }
        else {
          console.error('Handler is undefined: ' + handlerName);
        }
      }
    };

    var interface = {
      _init_: function () {
        registerPublicHandlers();
        bindEvents();
        delete interface._init_;
      },
      toString: function () {
        return name + ' (version ' + version + ')';
      },
    };

    return interface;
  }());

  // Error-safe initialization
  $(function () {
    try {
      m._init_();
    }
    catch (e) {
      console.error('Module failed to initialize: ' + m);
      console.error(e);
    }
  });

  return m;
}(jQuery));
